module.exports = __webpack_public_path__ + "img/个人空间.7e33ffb3.svg";